import * as React from "react";
import { PalettePicker, colorSchemesNames } from "@focus/focusUI";
import { Setting } from "@focus/commonComponents";
export class GrafosSettingsControl extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(Setting, { key: "settingsPalette", settingName: "chosenPalette" }, ({ setting }) => (React.createElement(PalettePicker, { defaultPalette: setting === undefined ? colorSchemesNames.SINEBOW : setting, height: 30, width: 500, onChange: (palette) => {
                this.props.updateSettings({
                    ["chosenPalette"]: palette,
                });
            } }))));
    }
}
//# sourceMappingURL=GrafosSettingsControl.js.map